"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_BY_LEVEL = exports.ALERT_LEVELS = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const typography_1 = __importDefault(require("../typography/typography"));
require("../../styles/components/alert-message.less");
exports.ALERT_LEVELS = {
    info: 'info',
    warning: 'warning',
    error: 'error',
    attention: 'attention',
};
exports.ICON_BY_LEVEL = {
    [exports.ALERT_LEVELS.info]: 'fa fa-exclamation-circle',
    [exports.ALERT_LEVELS.warning]: 'fa fa-exclamation-circle',
    [exports.ALERT_LEVELS.error]: 'fa fa-exclamation-triangle',
    [exports.ALERT_LEVELS.attention]: 'fa fa-exclamation-circle attention',
};
const AlertMessage = ({ className, level, text, bordered, onClick, warningId }) => {
    const onAlertClick = (0, react_1.useCallback)(() => {
        if (onClick) {
            onClick(warningId);
        }
    }, [onClick, warningId]);
    return (react_1.default.createElement("span", { className: (0, classnames_1.default)('alert-message', {
            [className]: className,
            [level]: level,
            bordered,
            is_clickable: !!onClick,
        }), onClick: onAlertClick },
        react_1.default.createElement("i", { className: `alert-icon ${exports.ICON_BY_LEVEL[level]}` }),
        react_1.default.createElement(typography_1.default, { variant: "caption" }, text)));
};
AlertMessage.defaultProps = {
    className: '',
    bordered: true,
    onClick: undefined,
    warningId: undefined,
};
AlertMessage.propTypes = {
    level: prop_types_1.default.oneOf(Object.keys(exports.ALERT_LEVELS)).isRequired,
    text: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]).isRequired,
    className: prop_types_1.default.string,
    bordered: prop_types_1.default.bool,
    onClick: prop_types_1.default.func,
    warningId: prop_types_1.default.string,
};
exports.default = AlertMessage;
//# sourceMappingURL=alert-message.js.map